import React, { useState, useEffect, useRef } from "react";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import humburger from "../../assets/images/humburger.png";
import uploadDoc from "../../assets/images/upload-doc.png";
import addFilter from "../../assets/images/add-filter.png";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Form from 'react-bootstrap/Form';
import crossImg from '../../assets/images/cross.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faCopy, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { getQuestionerById, publish, saveDraft, createTemplateApi } from "../../actions/riskManagement";
import { toastr } from 'react-redux-toastr';
import axios from "axios";
import { API_URL } from "../../utils/constant";

const animatedComponents = makeAnimated();

const StyledSelect = ({ options, value, onChange, placeholder, isMulti = false }) => {
  const customStyles = {
    control: (base) => ({
      ...base,
      background: 'white',
      borderColor: '#d0d0d0',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#08283f'
      }
    }),
    menu: (base) => ({
      ...base,
      background: 'white',
      border: '1px solid #d0d0d0',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      zIndex: 100
    }),
    option: (base, state) => ({
      ...base,
      background: state.isSelected ? '#08283f' : state.isFocused ? '#f5f5f5' : 'white',
      color: state.isSelected ? 'white' : '#333333',
      '&:hover': {
        background: state.isSelected ? '#08283f' : '#f5f5f5'
      }
    }),
    multiValue: (base) => ({
      ...base,
      background: '#f0f0f0',
      border: '1px solid #d0d0d0'
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#333333'
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#9e9e9e',
      '&:hover': {
        background: '#08283f',
        color: 'white'
      }
    }),
    input: (base) => ({
      ...base,
      color: '#333333'
    }),
    placeholder: (base) => ({
      ...base,
      color: '#666666'
    }),
    singleValue: (base) => ({
      ...base,
      color: '#333333'
    })
  };

  const customTheme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#08283f',
      primary25: '#2c2c2c',
      primary50: '#353535',
      neutral0: '#dadada',
      neutral10: '#f0f0f0',
      neutral20: '#d0d0d0',
      neutral30: '#b3b3b3',
      neutral40: '#cccccc',
      neutral50: '#9e9e9e',
      neutral60: '#b3b3b3',
      neutral70: '#cccccc',
      neutral80: '#e6e6e6',
      neutral90: '#f2f2f2'
    }
  });

  return (
    <Select
      components={isMulti ? animatedComponents : undefined}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isMulti={isMulti}
      theme={customTheme}
      styles={customStyles}
    />
  );
};

const questionControlsStyle = {
    buttonGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px'
    },
    controlButton: {
        padding: '6px 12px',
        borderRadius: '4px',
        border: '1px solid #e0e0e0',
        background: 'white',
        color: '#08283f',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        transition: 'all 0.2s ease',
        fontSize: '0.9rem',
        '&:hover': {
            background: '#f5f5f5',
            borderColor: '#08283f'
        }
    },
    moveButton: {
        padding: '6px',
        borderRadius: '4px',
        border: '1px solid #e0e0e0',
        background: 'white',
        color: '#666',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        '&:hover': {
            background: '#f5f5f5',
            color: '#08283f',
            borderColor: '#08283f'
        }
    },
    questionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '12px'
    },
    questionLabel: {
        fontSize: '0.9rem',
        color: '#666',
        marginBottom: '8px',
        fontWeight: 500
    }
};

const CreateTemplate = () => {
    const { orgId } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const { _id } = useParams();
    const id = useSelector((state) => orgId || state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
    const accessLevel = useSelector((state) => state?.auth?.user?.accessLevel);
    const [templateTitle, setTemplateTitle] = useState("Template Title");
    const [version, setVersion] = useState("1.0.0");
    const [isDefaultQuestionnaire, setIsDefaultQuestionnaire] = useState(false);
    const [categories, setCategories] = useState([
        {
            id: 1,
            name: "Category Name",
            questions: [
                {
                    id: 1,
                    questionText: "Question",
                    responseType: "Text",
                    options: [],
                    evidence: false,
                    showComment: false,
                    comment: "",
                    tier: "",
                    domains: []
                }
            ]
        }
    ]);
    const [domains, setDomains] = useState([]);
    const editQuestionnaireData = useSelector((state) => state?.riskManagement?.questionnaireById?.data);
    const [activeQuestionId, setActiveQuestionId] = useState(null);
    const [activeCategory, setActiveCategory] = useState(null);
    const [expandedCategories, setExpandedCategories] = useState(new Set([0]));
    const [isAllExpanded, setIsAllExpanded] = useState(false);
    const previewRef = useRef(null);
    const editorRef = useRef(null);

    useEffect(() => {
        const fetchDomains = async () => {
            try {
                const response = await axios.get(`${API_URL}/tprm/vendor-profiling/question-domains`);
                if (response.data) {
                    setDomains(response?.data?.data);
                }
            } catch (error) {
                // console.error removed
                toastr.error("Error", "Failed to fetch domains");
            }
        };

        fetchDomains();
    }, []);

    useEffect(() => {
        // Check for imported questionnaire data
        const importedQuestionnaire = localStorage.getItem('importedQuestionnaire');
        if (importedQuestionnaire) {
            const parsedData = JSON.parse(importedQuestionnaire);
            setTemplateTitle(parsedData.title);
            setVersion(parsedData.version);
            setCategories(parsedData.categories);

            // Create a new template to get an ID
            createTemplateApi(id).then(() => {
                // Clear the imported data from localStorage
                localStorage.removeItem('importedQuestionnaire');
            });
        } else if (_id) {
            // Existing logic for editing questionnaire
            setTemplateTitle(editQuestionnaireData?.title);
            setVersion(editQuestionnaireData?.version);
            const formattedCategories = editQuestionnaireData?.questions?.map((category, index) => ({
                id: index + 1,
                name: category?.categoryName,
                questions: category?.categoryQuestions?.map((question, qIndex) => ({
                    id: qIndex + 1,
                    questionText: question?.question_text,
                    responseType: question?.type == "multiple_choice_multi_select" ? "multiple_select" :
                        question?.type == "multiple_choice_single_select" ? "single_select" : "Text",
                    options: question?.options || [],
                    evidence: question?.evidence,
                    showComment: question?.showComment || false,
                    comment: question?.comment || "",
                    tier: question?.tier || "Medium",
                    domains: question?.domains || []
                }))
            }));
            setCategories(formattedCategories);
        }
    }, [editQuestionnaireData, _id, id]);

    const addCategory = () => {
        setCategories([...categories, {
            id: categories?.length + 1,
            name: "Category Name",
            questions: [
                {
                    id: categories.length + 1,
                    questionText: "Question",
                    responseType: "Text",
                    options: [],
                    evidence: false,
                    showComment: false,
                    comment: "",
                    tier: "",
                    domains: []
                }
            ]
        }]);
    };

    const addQuestion = (categoryId) => {
        setCategories(categories?.map(category =>
            category?.id === categoryId
                ? {
                    ...category,
                    questions: [...category?.questions, {
                        id: category?.questions.length + 1,
                        questionText: "Question",
                        responseType: "Text",
                        options: [],
                        evidence: false,
                        showComment: false,
                        comment: "",
                        tier: "",
                        domains: []
                    }]
                }
                : category
        ));
    };

    const addOption = (categoryId, questionId) => {
        setCategories(categories?.map(category =>
            category?.id === categoryId
                ? {
                    ...category,
                    questions: category?.questions?.map(q =>
                        q.id === questionId
                            ? { ...q, options: [...q?.options, ""] }
                            : q
                    )
                }
                : category
        ));
    };

    const updateQuestion = (categoryId, questionId, field, value) => {
        setCategories(categories?.map(category =>
            category?.id === categoryId
                ? {
                    ...category,
                    questions: category?.questions?.map(q =>
                        q.id === questionId ? { ...q, [field]: value } : q
                    )
                }
                : category
        ));
    };

    const removeCategory = (categoryId) => {
        setCategories(categories?.filter(category => category?.id !== categoryId));
    };

    const removeQuestion = (categoryId, questionId) => {
        setCategories(categories?.map(category =>
            category?.id === categoryId
                ? { ...category, questions: category?.questions?.filter(q => q?.id !== questionId) }
                : category
        ));
    };

    useEffect(() => {
        if (id && _id) {
            getQuestionerById(id, _id, dispatch)
        }
    }, [id, _id, dispatch])


    const duplicateCategory = (categoryId) => {
        const categoryToDuplicate = categories.find(cat => cat.id === categoryId);
        if (categoryToDuplicate) {
            const newCategory = {
                ...categoryToDuplicate,
                id: categories.length + 1,
                questions: categoryToDuplicate.questions.map((q, index) => ({
                    ...q,
                    id: index + 1
                }))
            };
            setCategories([...categories, newCategory]);
        }
    };

    const duplicateQuestion = (categoryId, questionId) => {
        setCategories(categories.map(category => {
            if (category.id === categoryId) {
                const questionToDuplicate = category.questions.find(q => q.id === questionId);
                if (questionToDuplicate) {
                    const newQuestion = {
                        ...questionToDuplicate,
                        id: category.questions.length + 1
                    };
                    return {
                        ...category,
                        questions: [...category.questions, newQuestion]
                    };
                }
            }
            return category;
        }));
    };

    const clearbutton = () => {
        setTemplateTitle("Template Title");
        setVersion("1.0.0");
        setCategories([{
            id: categories?.length + 1,
            name: "Category Name",
            questions: [
                {
                    id: categories?.length + 1,
                    questionText: "Question",
                    responseType: "Text",
                    options: [],
                    evidence: false,
                    showComment: false,
                    comment: "",
                    tier: "",
                    domains: []
                }
            ]
        }]);
    }

    const handleRouteChange = () => {
        history.push('/tprm/questionnaires');
    };

    const publishbtn = () => {
        if (templateTitle == "Template Title" || "") {
            toastr.error("Error", "Please enter the template title");
            return
        }
        if (version == "") {
            toastr.error("Error", "Please enter the version");
            return
        }
        const hasBlankOption = categories?.some(category =>
            category.questions.some(question =>
                (question.responseType === 'multiple_select' || question.responseType === 'single_select') &&
                question.options.some(option => option === '')
            )
        );
        if (hasBlankOption) {
            toastr.error("Error", "select questions cannot have blank options");
            return;
        }
        const draftData = {
            title: templateTitle,
            version,
            isGeneralQuestionnaire:isDefaultQuestionnaire,
            questions: categories?.map(category => ({
                categoryName: category?.name,
                categoryQuestions: category?.questions.map(question => ({
                    type: question?.responseType === 'Text' ? 'text' : question?.responseType === "multiple_select" ? 'multiple_choice_multi_select' : 'multiple_choice_single_select',
                    question_text: question?.questionText,
                    options: question?.options,
                    evidence: question?.evidence,
                    showComment: question?.showComment,
                    comment: question?.comment,
                    tier: question?.tier || "Medium",
                    domains: question?.domains || []
                }))
            })),
            id: _id || localStorage.getItem("createTemplateId")
        };
        publish(id, draftData, clearbutton, handleRouteChange)
    }

    const saveDraftButton = () => {
        if (templateTitle == "Template Title" || "") {
            toastr.error("Error", "Please enter the template title");
            return
        }
        if (version == "") {
            toastr.error("Error", "Please enter the version");
            return
        }
        const hasBlankOption = categories?.some(category =>
            category.questions.some(question =>
                (question.responseType === 'multiple_select' || question.responseType === 'single_select') &&
                question.options.some(option => option === '')
            )
        );
        if (hasBlankOption) {
            toastr.error("Error", "select questions cannot have blank options");
            return;
        }
        const draftData = {
            title: templateTitle,
            version,
            isGeneralQuestionnaire:isDefaultQuestionnaire,
            questions: categories?.map(category => ({
                categoryName: category?.name,
                categoryQuestions: category?.questions.map(question => ({
                    type: question?.responseType === 'Text' ? 'text' : question?.responseType === "multiple_select" ? 'multiple_choice_multi_select' : 'multiple_choice_single_select',
                    question_text: question?.questionText,
                    options: question?.options,
                    evidence: question?.evidence,
                    showComment: question?.showComment,
                    comment: question?.comment,
                    tier: question?.tier || "Medium",
                    domains: question?.domains || []
                }))
            })),
            id: _id || localStorage.getItem("createTemplateId")
        };
        saveDraft(id, draftData, clearbutton, handleRouteChange)
    }

    const moveQuestionUp = (categoryId, questionId) => {
        setCategories(categories.map(category => {
            if (category.id === categoryId) {
                const questions = [...category.questions];
                const currentIndex = questions.findIndex(q => q.id === questionId);
                if (currentIndex > 0) {
                    // Swap with previous question
                    [questions[currentIndex], questions[currentIndex - 1]] = 
                    [questions[currentIndex - 1], questions[currentIndex]];
                }
                return { ...category, questions };
            }
            return category;
        }));
    };

    const moveQuestionDown = (categoryId, questionId) => {
        setCategories(categories.map(category => {
            if (category.id === categoryId) {
                const questions = [...category.questions];
                const currentIndex = questions.findIndex(q => q.id === questionId);
                if (currentIndex < questions.length - 1) {
                    // Swap with next question
                    [questions[currentIndex], questions[currentIndex + 1]] = 
                    [questions[currentIndex + 1], questions[currentIndex]];
                }
                return { ...category, questions };
            }
            return category;
        }));
    };

    // Function to scroll to element in container
    const scrollToElement = (element, container, offset = 100) => {
        if (!element || !container) return;
        
        const elementPosition = element.offsetTop;
        container.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth'
        });
    };

    // Function to highlight element temporarily
    const highlightElement = (element) => {
        if (!element) return;
        element.style.backgroundColor = 'rgba(69, 58, 205, 0.2)';
        setTimeout(() => {
            element.style.backgroundColor = '';
        }, 1000);
    };

    // Function to handle question focus from either panel
    const handleQuestionFocus = (categoryId, questionId, fromPreview = false) => {
        setActiveQuestionId(questionId);
        setActiveCategory(categoryId);

        setTimeout(() => {
            // Handle accordion expansion
            const accordion = document.querySelector(`[data-category-id="${categoryId}"]`);
            if (accordion && !accordion.classList.contains('Mui-expanded')) {
                const summary = accordion.querySelector('.MuiAccordionSummary-root');
                if (summary) summary.click();
            }

            // Then scroll after accordion expansion
            setTimeout(() => {
                const previewElement = document.querySelector(`[data-preview-question="${questionId}"]`);
                const editorElement = document.querySelector(`[data-editor-question="${questionId}"]`);
                
                if (fromPreview) {
                    // Scroll editor into view
                    scrollToElement(editorElement, editorRef.current);
                    highlightElement(editorElement);
                } else {
                    // Scroll preview into view
                    scrollToElement(previewElement, previewRef.current);
                    highlightElement(previewElement);
                }
            }, 300);
        }, 0);
    };

    // Function to toggle all categories
    const toggleAllCategories = () => {
        if (isAllExpanded) {
            setExpandedCategories(new Set());
        } else {
            setExpandedCategories(new Set(categories.map((_, index) => index)));
        }
        setIsAllExpanded(!isAllExpanded);
    };

    // Function to handle individual category toggle
    const handleCategoryToggle = (categoryIndex) => {
        setExpandedCategories(prev => {
            const newExpanded = new Set(prev);
            if (newExpanded.has(categoryIndex)) {
                newExpanded.delete(categoryIndex);
            } else {
                newExpanded.add(categoryIndex);
            }
            return newExpanded;
        });
    };

    return (
        <div className="container-fluid risk-dashboard">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Third Party Risk Management</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/tprm/questionnaires" className="welcome-textSmall">
                                        Third Party Risk Management
                                    </Link>
                                    &nbsp;/&nbsp;
                                    <Link to="/tprm/questionnaires" className="welcome-textSmall">
                                        Manage Questionnaires
                                    </Link>
                                    &nbsp;/&nbsp;Questionnaire Template Editor
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="body">
                    <div className="row">
                        <div className="col-md-6">
                            <div 
                                ref={editorRef}
                                style={{ 
                                    maxHeight: 'calc(100vh - 200px)', 
                                    overflowY: 'auto',
                                    position: 'relative'
                                }}
                            >
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div style={{ width: "70%", marginRight: "10px" }}>
                                        <label className="form-label mb-1" style={{ fontWeight: 300 }}>Template Title</label>
                                        <div className="input-group">
                                            <input type="text" className="form-control border-0 inputUpdateLastest"
                                                value={templateTitle}
                                                onChange={(e) => setTemplateTitle(e.target.value)}
                                                placeholder="brandsek template /  Title required" />
                                        </div>
                                    </div>
                                    <h5 className="mb-0">Editor</h5>
                                    <button 
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={toggleAllCategories}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                            padding: '6px 12px',
                                            fontSize: '0.875rem'
                                        }}
                                    >
                                        <FontAwesomeIcon icon={isAllExpanded ? faChevronUp : faChevronDown} />
                                        {isAllExpanded ? 'Collapse All' : 'Expand All'}
                                    </button>
                                </div>
                                {categories?.map((category, categoryIndex) => (
                                    <Accordion 
                                        key={categoryIndex}
                                        expanded={expandedCategories.has(categoryIndex)}
                                        onChange={() => handleCategoryToggle(categoryIndex)}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls={`editor-panel${categoryIndex}-content`}
                                            id={`editor-panel${categoryIndex}-header`}
                                        >
                                            <div className="d-flex align-items-center justify-content-between w-100 pe-3">
                                                <input
                                                    type="text"
                                                    className="form-control border-0 inputUpdateLastest"
                                                    placeholder="Category Name"
                                                    value={category?.name}
                                                    onChange={(e) =>
                                                        setCategories(categories?.map(cat =>
                                                            cat?.id === category?.id ? { ...cat, name: e.target.value } : cat
                                                        ))
                                                    }
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                                <span className="boxButton ms-2">
                                                    {category?.questions?.length}
                                                </span>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {category?.questions?.map((question) => (
                                                <div 
                                                    key={question?.id} 
                                                    className={`group-box mb-3 ${activeQuestionId === question?.id ? 'active-question' : ''}`}
                                                    data-editor-question={question?.id}
                                                    onClick={() => handleQuestionFocus(category?.id, question?.id, false)}
                                                >
                                                    <div className="categoryBox">
                                                        <div style={questionControlsStyle.questionHeader}>
                                                            <div style={{ flex: 1 }}>
                                                                <label style={questionControlsStyle.questionLabel}>Question</label>
                                                                <div style={questionControlsStyle.buttonGroup}>
                                                                    <button 
                                                                        style={questionControlsStyle.moveButton}
                                                                        onClick={() => moveQuestionUp(category?.id, question?.id)}
                                                                        title="Move Up"
                                                                    >
                                                                        <FontAwesomeIcon icon={faSortUp} style={{ fontSize: '1.1rem' }} />
                                                                    </button>
                                                                    <button 
                                                                        style={questionControlsStyle.moveButton}
                                                                        onClick={() => moveQuestionDown(category?.id, question?.id)}
                                                                        title="Move Down"
                                                                    >
                                                                        <FontAwesomeIcon icon={faSortDown} style={{ fontSize: '1.1rem' }} />
                                                                    </button>
                                                                    <button 
                                                                        style={questionControlsStyle.controlButton}
                                                                        onClick={() => duplicateQuestion(category?.id, question?.id)}
                                                                    >
                                                                        <FontAwesomeIcon icon={faCopy} style={{ fontSize: '0.9rem' }} />
                                                                        Duplicate
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <textarea
                                                            placeholder="Enter your question here..."
                                                            className="form-control border-0 inputUpdateLastest"
                                                            value={question?.questionText}
                                                            onChange={(e) =>
                                                                updateQuestion(category?.id, question?.id, "questionText", e.target.value)
                                                            }
                                                            onFocus={() => handleQuestionFocus(category?.id, question?.id, false)}
                                                            style={{
                                                                minHeight: '80px',
                                                                resize: 'vertical',
                                                                padding: '12px',
                                                                fontSize: '0.95rem',
                                                                lineHeight: '1.5'
                                                            }}
                                                        ></textarea>
                                                    </div>
                                                    <div className="flex items-end justify-content-between gap-2 mt-3">
                                                        <div>
                                                            <div className="d-flex justify-content-between">
                                                                <div className="relative mr-2">
                                                                    <div className="filter-container">
                                                                        <StyledSelect
                                                                            options={[
                                                                                { value: "Text", label: "Text" },
                                                                                { value: "multiple_select", label: "Multi Select" },
                                                                                { value: "single_select", label: "Single Select" }
                                                                            ]}
                                                                            value={{ value: question?.responseType, label: question?.responseType === "Text" ? "Text" : 
                                                                                    question?.responseType === "multiple_select" ? "Multi Select" : "Single Select" }}
                                                                            onChange={(selectedOption) => 
                                                                                updateQuestion(category?.id, question?.id, "responseType", selectedOption.value)
                                                                            }
                                                                            placeholder="Select Response Type"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="flex items-center customLabelBox">
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id={`evidence-${category.id}-${question.id}`}
                                                                        label="Evidence"
                                                                        checked={question?.evidence}
                                                                        onChange={(e) => {
                                                                            const updatedCategories = categories?.map(cat => {
                                                                                if (cat?.id === category?.id) {
                                                                                    return {
                                                                                        ...cat,
                                                                                        questions: cat?.questions?.map(q => {
                                                                                            if (q?.id === question?.id) {
                                                                                                return { ...q, evidence: e.target.checked };
                                                                                            }
                                                                                            return q;
                                                                                        })
                                                                                    };
                                                                                }
                                                                                return cat;
                                                                            });
                                                                            setCategories(updatedCategories);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* Add Tier Selection */}
                                                            <div className="mt-2 mb-2">
                                                                <label className="text-sm mb-1">Tier</label>
                                                                <div className="filter-container">
                                                                    <StyledSelect
                                                                        options={[
                                                                            { value: "High", label: "High" },
                                                                            { value: "Medium", label: "Medium" },
                                                                            { value: "Low", label: "Low" }
                                                                        ]}
                                                                        value={question?.tier ? { value: question.tier, label: question.tier } : null}
                                                                        onChange={(selectedOption) => 
                                                                            updateQuestion(category?.id, question?.id, "tier", selectedOption.value)
                                                                        }
                                                                        placeholder="Select Tier"
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* Add Domain Selection */}
                                                            <div className="mt-2 mb-2">
                                                                <label className="text-sm mb-1">Domains</label>
                                                                <div className="filter-container">
                                                                    <StyledSelect
                                                                        options={domains.map(domain => ({
                                                                            value: domain?.label, 
                                                                            label: domain?.label
                                                                        }))}
                                                                        value={question?.domains?.map(domain => ({ 
                                                                            value: domain, 
                                                                            label: domain 
                                                                        })) || []}
                                                                        onChange={(selectedOptions) => {
                                                                            const selectedDomains = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                                            updateQuestion(category?.id, question?.id, "domains", selectedDomains);
                                                                        }}
                                                                        placeholder="Select Domains"
                                                                        isMulti={true}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {question?.responseType === "multiple_select" || question?.responseType === "single_select" ? (
                                                                <>
                                                                    {question?.options?.length === 0 && (
                                                                        setCategories(categories?.map(cat =>
                                                                            cat?.id === category?.id
                                                                                ? {
                                                                                    ...cat,
                                                                                    questions: cat?.questions?.map(q =>
                                                                                        q?.id === question?.id
                                                                                            ? {
                                                                                                ...q,
                                                                                                options: [""]
                                                                                            }
                                                                                            : q
                                                                                    )
                                                                                }
                                                                                : cat
                                                                        ))
                                                                    )}
                                                                    {question?.options?.map((option, index) => (
                                                                        <div key={index} className="d-flex align-items-center optionInput">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control mt-2 mb-2 border-0 inputUpdateLastest"
                                                                                placeholder={`Option ${index + 1}`}
                                                                                defaultValue={option}
                                                                                onChange={(e) =>
                                                                                    setCategories(categories?.map(cat =>
                                                                                        cat?.id === category?.id
                                                                                            ? {
                                                                                                ...cat,
                                                                                                questions: cat?.questions?.map(q =>
                                                                                                    q?.id === question?.id ? {
                                                                                                        ...q,
                                                                                                        options: q?.options?.map((opt, idx) =>
                                                                                                            idx === index ? e.target.value : opt
                                                                                                        )
                                                                                                    }
                                                                                                        : q
                                                                                            )
                                                                                        }
                                                                                        : cat
                                                                                ))
                                                                            }
                                                                        />
                                                                        <img
                                                                            src={crossImg}
                                                                            className="img-fluid ml-2"
                                                                            alt="Delete Option"
                                                                            onClick={() => {
                                                                                setCategories(categories?.map(cat =>
                                                                                    cat?.id === category?.id
                                                                                        ? {
                                                                                            ...cat,
                                                                                            questions: cat?.questions?.map(q =>
                                                                                                q?.id === question?.id
                                                                                                    ? {
                                                                                                        ...q,
                                                                                                        options: q?.options?.filter((_, idx) => idx !== index)
                                                                                                    }
                                                                                                    : q
                                                                                            )
                                                                                        }
                                                                                        : cat
                                                                                ))
                                                                            }}
                                                                        />
                                                                        </div>
                                                                    ))}
                                                                    {question.showComment && (
                                                                        <div className="mt-3">
                                                                            <textarea
                                                                                className="form-control form-control-review border-0 inputUpdateLastest"
                                                                                placeholder="Comment"
                                                                                disabled
                                                                                value={question.comment || ""}
                                                                                row="4"
                                                                                onChange={(e) => {
                                                                                    setCategories(categories?.map(cat =>
                                                                                        cat?.id === category?.id
                                                                                            ? {
                                                                                                ...cat,
                                                                                                questions: cat?.questions?.map(q =>
                                                                                                    q?.id === question?.id
                                                                                                        ? { ...q, comment: e.target.value }
                                                                                                        : q
                                                                                                )
                                                                                            }
                                                                                            : cat
                                                                                    ))
                                                                                }}
                                                                            ></textarea>
                                                                        </div>
                                                                    )}
                                                                    <div className="d-flex align-items-center mt-2">
                                                                        <span className="addOptions mr-3" onClick={() => addOption(category?.id, question?.id)}>
                                                                            Add Options +
                                                                        </span>
                                                                        <span
                                                                            className="addOptions"
                                                                            onClick={() => {
                                                                                setCategories(categories?.map(cat =>
                                                                                    cat?.id === category?.id
                                                                                        ? {
                                                                                            ...cat,
                                                                                            questions: cat?.questions?.map(q =>
                                                                                                q?.id === question?.id
                                                                                                    ? {
                                                                                                        ...q,
                                                                                                        showComment: !q.showComment,
                                                                                                        comment: !q.showComment ? q.comment : ""
                                                                                                    }
                                                                                                    : q
                                                                                            )
                                                                                        }
                                                                                        : cat
                                                                                ))
                                                                            }}
                                                                        >
                                                                            {question.showComment ? 'Remove Comment' : 'Add Comment'}
                                                                        </span>
                                                                    </div>
                                                                </>
                                                            ) : null}
                                                        </div>
                                                        <button className="remove-button m-0" onClick={() => removeQuestion(category?.id, question?.id)}>
                                                            Remove
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                            <button className="btn btn-primary btnQuestion btn-trans" onClick={() => addQuestion(category?.id)}>
                                                Add Question <span>+</span>
                                            </button>
                                            <button className="remove-button" onClick={() => removeCategory(category?.id)}>Remove Category</button>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                                <button className="btn btn-primary btnQuestion btn-trans mt-2" onClick={addCategory}>
                                    Add new Category <span>+</span>
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div 
                                className="group-box group-box-template" 
                                ref={previewRef}
                                style={{ 
                                    maxHeight: 'calc(100vh - 200px)', 
                                    overflowY: 'auto',
                                    position: 'relative'
                                }}
                            >
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="boxAVersion">
                                        <p className="mb-0">{templateTitle}</p>
                                        <p className="mb-0">{version}</p>
                                    </div>
                                    <button 
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={toggleAllCategories}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                            padding: '6px 12px',
                                            fontSize: '0.875rem'
                                        }}
                                    >
                                        <FontAwesomeIcon icon={isAllExpanded ? faChevronUp : faChevronDown} />
                                        {isAllExpanded ? 'Collapse All' : 'Expand All'}
                                    </button>
                                </div>
                                <div>
                                    {categories?.map((category, categoryIndex) => (
                                        <Accordion 
                                            key={categoryIndex}
                                            expanded={expandedCategories.has(categoryIndex)}
                                            onChange={() => handleCategoryToggle(categoryIndex)}
                                            data-category-id={category.id}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls={`preview-panel${categoryIndex}-content`}
                                                id={`preview-panel${categoryIndex}-header`}
                                            >
                                                {category?.name}
                                                <span className="boxButton">
                                                    {category?.questions?.length}
                                                </span>
                                            </AccordionSummary>
                                            {category?.questions?.map((question, qIndex) => (
                                                <AccordionDetails 
                                                    key={qIndex}
                                                    data-preview-question={question?.id}
                                                    className={`preview-question ${activeQuestionId === question?.id ? 'active-preview-question' : ''}`}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleQuestionFocus(category?.id, question?.id, true);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div className="boxAccordian">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p>
                                                                {qIndex + 1}. {question?.questionText}
                                                            </p>
                                                            <img src={humburger} className="img-fluid" alt="Menu" />
                                                        </div>
                                                        {question?.evidence == true && (
                                                            <label className="uploadDoc">
                                                                <input type="file" className="d-none" />
                                                                Upload Documents
                                                                <img src={uploadDoc} className="img-fluid" alt="upload document icon" />
                                                            </label>
                                                        )}
                                                        <div className="mb-4">
                                                            {question?.responseType === 'Text' ? (
                                                                <textarea
                                                                    className="form-control form-control-review border-0 inputUpdateLastest"
                                                                    rows="4"
                                                                    placeholder="Response"
                                                                    disabled
                                                                ></textarea>
                                                            ) : (
                                                                <>
                                                                    {question?.options?.map((option, optIndex) => (
                                                                        <span
                                                                            key={optIndex}
                                                                            className={`form-control w-50 mt-2 mb-3 border-0 inputUpdateLastest ${question?.response?.value?.includes(option)
                                                                                ? "selectedOption"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {option}
                                                                        </span>
                                                                    ))}
                                                                    {question.showComment && (
                                                                        <div className="mt-3">
                                                                            <textarea
                                                                                className="form-control form-control-review border-0 inputUpdateLastest"
                                                                                rows="4"
                                                                                value={question.comment || ""}
                                                                                placeholder="Comment"
                                                                                disabled
                                                                            ></textarea>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                            <hr style={{ borderTop: '1px solid #433f3f', width: '50%', margin: 'auto', marginTop: '30px' }} />
                                                        </div>
                                                    </div>
                                                </AccordionDetails>
                                            ))}
                                        </Accordion>
                                    ))}
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-end">
                                {accessLevel == "super-admin" && <>
                                    <div className="me-3 mt-3 d-flex align-items-center">
                                        <Form.Check
                                            type="checkbox"
                                            id="isDefaultQuestionnaire"
                                            label="Set as general Questionnaire"
                                            className="me-2"
                                            onChange={(e => setIsDefaultQuestionnaire(e.target.checked))}
                                            checked={isDefaultQuestionnaire}
                                        />
                                    </div>
                                </>}
                                <button className="send-button mt-3" onClick={() => saveDraftButton()}>Save Draft</button>
                                <button className="send-button mt-3" onClick={() => publishbtn()}>Publish</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const additionalStyles = `
    .active-question {
        border-left: 3px solid #08283f;
        background-color: rgba(69, 58, 205, 0.05);
    }

    .active-preview-question {
        background-color: rgba(69, 58, 205, 0.05);
    }

    .preview-question {
        transition: background-color 0.3s ease;
    }

    .preview-question:hover {
        background-color: rgba(69, 58, 205, 0.05);
    }

    .group-box-template {
        scroll-behavior: smooth;
    }

    .boxAccordian {
        transition: background-color 0.3s ease;
    }

    .btn-outline-primary {
        border-color: #08283f;
        color: #08283f;
    }

    .btn-outline-primary:hover {
        background-color: #08283f;
        color: white;
    }
`;

const styleSheet = document.createElement("style");
styleSheet.innerText = additionalStyles;
document.head.appendChild(styleSheet);

export default CreateTemplate;